import { MAPS_LINK_CHILE } from '../links';

const chileFooter = {
  slogan: 'Transform the way companies interact',
  tyc: {
    text: 'Términos y condiciones',
    navigateTo: '/terms',
  },
  legalNotice: 'fingo @ 2025. Todos los derechos reservados.',
  contactInformation: [
    {
      title: 'Dirección',
      address: 'Av. Apoquindo 4660, Las Condes Piso 8',
      navigateTo: MAPS_LINK_CHILE,
    },
    {
      title: 'Comercial',
      phone: ['+56 9 7959 9463', '+56 9 3525 5478'],
      email: 'contacto@fingo.cl',
    },
    {
      title: 'Cobranza',
      phone: '+56 9 9840 9937',
      email: 'cobranza_ratificacion@fingo.cl',
    },
  ],
};

export default chileFooter;
